export var tableActionDefaultTheme = {
  Root: {
    base: {
      fontFamily: '$typography.body.fontFamily',
      color: '$color.neutral.05',
      '&:hover': {
        color: '$color.primary.main'
      }
    }
  }
};